import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import {OwnerAssistEntity, Ownership, Report, SelectorItem, Status} from 'src/app/model';
import { ReportService } from 'src/app/services';

@Component({
  selector: 'app-wizard-owner-salary-popup',
  templateUrl: './wizard-owner-salary-popup.component.html',
  styleUrls: ['./wizard-owner-salary-popup.component.scss']
})
export class WizardOwnerSalaryPopupComponent implements OnInit, OnDestroy {

  @ViewChild('wizardForm') wizardForm: NgForm;
  public currentReport: Report;
  private reportSub: Subscription;
  subject: Subject<any>;

  selectedOwner: Ownership = null;
  scenario: number;
  showOverflow: boolean = false;
  overFlowTimeout: any;

  scenario2Value: number;
  ownerList: Array<SelectorItem> = [];

  constructor(
    public reportService: ReportService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
    this.scenario2Value = null;
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport?.LATEST)
        this.onInitData();
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /** Cancel click */
  cancel() {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  onInitData(): void {
    if (this.currentReport.LATEST?.OWNERSHIP_LIST?.length) {
      this.currentReport.LATEST.OWNERSHIP_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
      let combinedWorkHours = this.reportService.ownersCombinedWork();
      if (combinedWorkHours < 50) {
        this.scenario = 1;
      } else if (combinedWorkHours >= 50 && this.currentReport.LATEST.OWNERSHIP_LIST.length === 2) {
        this.scenario = 2; // >> Sub Scenario is [3]
      } else if (combinedWorkHours >= 50 && this.currentReport.LATEST.OWNERSHIP_LIST.length > 2) {
        this.scenario = 4; // >> Sub Scenario is [5]
        this.clearSelectedOwners();
      }

      this.currentReport.LATEST.OWNERSHIP_LIST.forEach(owner => {
        if(owner.HOURS > 0){
          this.ownerList.push(new SelectorItem(owner.NAME, owner, null));
        }
      })
    }
  }

  private clearSelectedOwners(): void {
    for (let i = 0; i < this.currentReport.LATEST.OWNERSHIP_LIST.length; i++) {
      this.currentReport.LATEST.OWNERSHIP_LIST[i].selected = false;
    }
  }

  mainOwnerChanged(owner: Ownership): void {
    if (owner) {
      if (this.scenario === 2 || this.scenario === 3) {
        if (owner.HOURS >= 50) {
          this.scenario = 3;
        } else {
          this.scenario = 2;
        }
      } else if (this.scenario === 4 || this.scenario === 5) {
        if (owner.HOURS >= 50) {
          this.scenario = 5;
        } else {
          this.scenario = 4;
          this.clearSelectedOwners();
        }
      }
    }
  }

  getTotalHoursOwners(): number {
      if (this.selectedOwner) {
      let sum = this.currentReport.LATEST.OWNERSHIP_LIST.filter(({selected, ID}) => selected === true && ID !== this.selectedOwner.ID).reduce((summ, v) => (summ += Number(v.HOURS) || 0), 0);
      sum += Number(this.selectedOwner.HOURS);
      return sum;
    } else {
      return 0;
    }
  }

  scenario4CheckboxDisabled(owner: Ownership): boolean {
    return (this.getTotalHoursOwners() + Number(owner.HOURS)) > 50 && !owner.selected;
  }

  onAccept(): void {
    const mainOwnerID = this.selectedOwner.ID;
    let objFieldArray = new Array<OwnerAssistEntity>();

    this.currentReport.LATEST.OWNERSHIP_LIST.forEach(element => {
      if (element.ID !== mainOwnerID) {
        const objAssistEntity = new OwnerAssistEntity();
        objAssistEntity.ID = element.ID;
        objAssistEntity.VALUE = element.REPLACEMENT_SALARY_TEMP ? Number(element.REPLACEMENT_SALARY_TEMP) : 0;
        objAssistEntity.IS_EXCLUDED = element.selected ? element.selected : false;
        objFieldArray.push(objAssistEntity);
      }
    });

    const param = {
      mainOwnerID: mainOwnerID,
      ownerArray: objFieldArray
    }

    this.bsModalRef.hide();
    this.subject.next(param);
    this.subject.complete();

  }

  getSecondOwner(): Ownership {
    if (this.selectedOwner) {
      for (let i = 0; i < this.currentReport.LATEST.OWNERSHIP_LIST.length; i++) {
        if (this.selectedOwner.ID !== this.currentReport.LATEST.OWNERSHIP_LIST[i].ID) {
          return this.currentReport.LATEST.OWNERSHIP_LIST[i];
        }
      }
    }
    return null;
  }

  ownerListClicked(disabled: boolean): void {
    if (disabled) {
      this.showOverflow = true;

      clearTimeout(this.overFlowTimeout);
      this.overFlowTimeout = setTimeout(() => {
        this.showOverflow = false;
      }, 1500);
    }
  }

  getApproxValue2nd(): number {
    return ((Number(this.selectedOwner.HOURS) + Number(this.getSecondOwner().HOURS)) - 50);
  }

  getFilteredOwner(): Array<Ownership> {
    return this.currentReport.LATEST.OWNERSHIP_LIST.filter(owner => owner.ID !== this.selectedOwner?.ID && owner.HOURS > 0);
  }

  getFilteredOwnerSalary(): Array<Ownership> {
    return this.currentReport.LATEST.OWNERSHIP_LIST.filter(owner => owner.ID !== this.selectedOwner?.ID && owner.HOURS > 0 && !owner.selected);
  }

  protected readonly Status = Status;
}
